import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H6 } from '#app/components/typography/h6.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Parts, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H6',
}

const component: componentProps = {
	name: 'H6',
	shortName: 'H6',
	fileName: 'h6',
	category: 'typography',
	description: ['H6 heading component.'],
	features: ['Drop-in replacement for the native <h6> element.', "Opts-in to your design system's typographic styles."],
	parts: [],
	usage: `<H6>This is an h6 heading</H6>`,
	styling: `
.h6 {
	@apply text-fluid-md text-muted-900 max-w-prose font-sans font-bold;
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, parts, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<H6>This is an h6 heading</H6>
			<Features features={features} />
			<Parts parts={parts} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
